var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAds28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.402 3.9c1.24-.532 2.64-.124 3.074 1.153.508 1.496 1.024 3.89 1.024 7.447 0 3.562-.518 6.088-1.026 7.71-.433 1.38-1.938 1.877-3.268 1.307l-6.388-2.738A3 3 0 0 1 14 16.022V9.478a3 3 0 0 1 1.818-2.757l6.584-2.822ZM1.255 13a5 5 0 0 1 5-5h3.353C10.377 8 11 8.623 11 9.392v6.492c0 1.108.036 2.013.33 3.114l1.348 5.026a1.5 1.5 0 0 1-1.061 1.837c-2.166.58-3.143.443-3.719-1.708l-1.351-5.042c-.176-.656-.777-1.088-1.438-1.243A5.002 5.002 0 0 1 1.255 13Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds28);
export default __webpack_public_path__ + "static/media/ads_28.359fff10.svg";
export { ForwardRef as ReactComponent };